import axios from 'axios';
const baseUrl = process.env.VUE_APP_NEW_API_BASE_URL;
const apiPrefix = process.env.VUE_APP_NEW_API_PREFIX;
const testToken = process.env.VUE_APP_ORANGE_LOGIN_TOKEN;

const verifyUserPrefix = process.env.VUE_WEB_APP_USER_PREFIX || '/v5';

const getOrangeLoginCredentials = () => (
  axios({
    method: 'get',
    url: `${baseUrl}${apiPrefix}/authentication/orange-user`,
  })
);

const verifyPartner = ({ name, subscriptionId, operationId }) => (
  axios.post(
    `${baseUrl}${verifyUserPrefix}/partners/verify-user`,
    JSON.stringify({ 
      name: name,
      user: {
          subscriptionId: subscriptionId,
          operationId: operationId
       },
     }),
  )
);

const validateOrangeLogin = () => (
  getOrangeLoginCredentials()
    .then(({ data: { authProcessURI, userAuthToken }}) => {

      return axios({
        method: 'get',
        url: authProcessURI,
      })
        .then(() => {
          return { userAuthToken };
        })
        .catch((err) => {
          return testToken ? { userAuthToken } : err.response;
        })
    })
);

export default {
 getPartnerAlias  ({ name, subscriptionId, operationId }) {
  return verifyPartner({ name, subscriptionId, operationId })
  .then((res) => {
   
    if (res.status === 200) {
      return res.data;
    }
  }).catch((err) => err)
},
  getOrangeAlias() {
    return validateOrangeLogin()
      .then((res) => {
        const { status, userAuthToken  } = res;

        if (status === 401) {
          return data;
        }

        return axios({
          method: 'post',
          url: `${baseUrl}${apiPrefix}/orange-user`,
          params: { tokenRequest: testToken ? testToken : userAuthToken },
        })
          .then(({ data }) => {
            return { userAlias: data.userAlias };
          })
          .catch((err) => err)
      })
  },
};